<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Add employee"></aw-bread-crumb>

  <aw-dialog
    [visible]="openEmployeeInfoDialog"
    [dialogOptions]="dialogOptions"
    (primaryAction)="dialogCloseHandler()"
    ariaLabel="Employee created successfully"
  >
  </aw-dialog>

  <aw-toast></aw-toast>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'New Employee'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="form-container">
    <!-- Employee Name Field -->
    <app-aw-text-form
      class="input"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      title="Employee Name"
      (textEntry)="onEmployeeNameSelected($event)"
    ></app-aw-text-form>

    <!-- Employee Email Address Field -->
    <app-aw-text-form
      class="input"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      title="Employee Email"
      (textEntry)="onEmployeeEmailSelected($event)"
    ></app-aw-text-form>

    <!-- Organization ID Field -->
    <app-aw-text-form
      class="input"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      title="Integration ID"
      (textEntry)="onOrganizationIDSelected($event)"
    ></app-aw-text-form>
  </div>
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"> </aw-action-bar>
</div>
